// Docs: IMPLEMENTATION.md (hint matching).
//
// In-memory store behind `useHintForms`, keyed by word id. Separate from the
// hook so `queryPersistence.clearPersistedCache` can wipe it on logout
// without importing the hook (which would close an import cycle back through
// services/api).
//
// Word ids are per-user, so this holds account data and falls under the same
// rule as the persisted query cache: clear it wherever the JWT is cleared, or
// the next account to sign in on this device can read the previous one's
// forms out of a colliding id.

const hintFormsCache = new Map();

export const getCachedHintForms = (wordId) => hintFormsCache.get(wordId);

export const setCachedHintForms = (wordId, pending) => {
  hintFormsCache.set(wordId, pending);
};

export const deleteCachedHintForms = (wordId) => {
  hintFormsCache.delete(wordId);
};

export const clearHintFormsCache = () => {
  hintFormsCache.clear();
};
